import React from 'react';
import PropTypes from 'prop-types';

function Card(props) {
  const {
    component: ComponentProp,
    classes,
    className,
    raised,
    location,
    navigate,
    pageContext,
    ...other
  } = props;
  const Component = ComponentProp || 'div';

  // Location prop somehow causes an error when its passed into this component.

  return <Component className={className} {...other} />;
}

Card.propTypes = {
  /**
   * @ignore
   */
  component: PropTypes.string,
  className: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Card = ({prop = val, component = 'div', className = '' }) =>

export default Card;
